import React, { createContext, useContext, useState, useCallback } from 'react';
import { TRANSLATIONS, UI_LANGUAGES } from './constants/i18n';

const I18nContext = createContext({ locale: 'en', t: (k) => k, setLocale: () => {} });

export function I18nProvider({ children }) {
  const [locale, setLocaleRaw] = useState(() => localStorage.getItem('gwv_ui_lang') || 'en');

  const setLocale = useCallback((code) => {
    setLocaleRaw(code);
    localStorage.setItem('gwv_ui_lang', code);
  }, []);

  const t = useCallback((key) => {
    return TRANSLATIONS[locale]?.[key] || TRANSLATIONS.en?.[key] || key;
  }, [locale]);

  return (
    <I18nContext.Provider value={{ locale, setLocale, t, languages: UI_LANGUAGES }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
